import { useQuery, UseQueryOptions } from 'react-query';
import { SchemaIO, SchemaTenantService } from '@frontend/schema';
import { getTenantsWithOrgIds, getTenantDetails } from './api';

export const usePhoneTenantsQuery = <T extends unknown>({
  userId,
  orgIds,
  select,
  enabled = true,
}: {
  userId: string;
  orgIds: string[];
  select?: (data: SchemaIO<(typeof SchemaTenantService)['GetTenants']>['output'][]) => T;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ['tenants', userId],
    queryFn: () => getTenantsWithOrgIds(orgIds),
    select,
    enabled,
  });
};

type Res = Awaited<ReturnType<typeof getTenantDetails>>;
export const useTenantDetailsQuery = (tenantId: string, options: UseQueryOptions<unknown, unknown, Res> = {}) => {
  return useQuery({
    queryKey: ['tenantDetails', tenantId],
    queryFn: () => getTenantDetails(tenantId),
    ...options,
  });
};
